<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelims-head">DEdication</h1>
<p class="Prelims-main">To my son Jon for giving me the ‘push’ that I needed, and to my grandson Nicholas for the inspiration.  Thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398418653_EPUB-1.vue?73aa29e7